import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { API_URL } from "../../../utils/constant";
import axios from "axios";

export const getVisionSliceContent = createAsyncThunk('/vision/content', async () => {
    var userData=JSON.parse(localStorage.getItem("userData"));
	const response = await axios.post(`${API_URL}/getVision`, {});
	return response;
})

export const visionSlice = createSlice({
    name: 'vision',
    initialState: {
        isLoading: false,
        vision : []
    },
    reducers: {
    },
    extraReducers: {
		[getVisionSliceContent.pending]: state => {
			state.isLoading = true
		},
		[getVisionSliceContent.fulfilled]: (state, action) => {
			state.vision = action.payload.data
			state.isLoading = false
		},
		[getVisionSliceContent.rejected]: state => {
			state.isLoading = false
		},
    }
})

export default visionSlice.reducer